import { render, staticRenderFns } from "./iframeUrl.vue?vue&type=template&id=42ddd934&scoped=true&"
import script from "./iframeUrl.vue?vue&type=script&lang=js&"
export * from "./iframeUrl.vue?vue&type=script&lang=js&"
import style0 from "./iframeUrl.vue?vue&type=style&index=0&id=42ddd934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ddd934",
  null
  
)

export default component.exports